import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "valueChange", "onChange", "valueKey", "labelKey", "defaultValue", "error", "errMessage", "className", "label", "size", "formTitleDirection", "formTitle", "formTitleClassName", "formTitleSlot", "hideClearButton", "options"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "valueChange", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useState } from 'react';
import { getCountryNormalLogoUrl, useLocalTranslation } from '@jove-frontend/uikit';
import { CloseOutlined } from '@mui/icons-material';
import { Autocomplete, Box, FormHelperText, TextField, Typography } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { JoveFormTitleDirectionEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var JoveCountrySelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var value = props.value,
      valueChange = props.valueChange,
      onChange = props.onChange,
      _props$valueKey = props.valueKey,
      valueKey = _props$valueKey === void 0 ? 'code' : _props$valueKey,
      _props$labelKey = props.labelKey,
      labelKey = _props$labelKey === void 0 ? 'name' : _props$labelKey,
      defaultValue = props.defaultValue,
      error = props.error,
      errMessage = props.errMessage,
      className = props.className,
      _props$label = props.label,
      label = _props$label === void 0 ? $t('kit:components.choose_country') : _props$label,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$formTitleDirec = props.formTitleDirection,
      formTitleDirection = _props$formTitleDirec === void 0 ? JoveFormTitleDirectionEnum.top : _props$formTitleDirec,
      formTitle = props.formTitle,
      formTitleClassName = props.formTitleClassName,
      formTitleSlot = props.formTitleSlot,
      hideClearButton = props.hideClearButton,
      options = props.options,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState([]),
      selectValue = _useState[0],
      setSelectValue = _useState[1];

  var _useState2 = useState(options || []),
      canSelectOptions = _useState2[0],
      setCanSelectOptions = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    setCanSelectOptions(options || []);
  }, [options]);
  /**
   * methods
   */

  var selectValueChangeAction = function selectValueChangeAction(e, value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    setSelectValue(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: clsx('flex flex-col', className),
    children: [formTitleDirection === JoveFormTitleDirectionEnum.top && (formTitleSlot ? formTitleSlot : /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle2",
      className: clsx('mb-[2px] font-bold', formTitleClassName),
      style: {
        color: props !== null && props !== void 0 && props.disabled ? 'rgba(0, 0, 0, 0.38)' : undefined
      },
      children: formTitle
    })), /*#__PURE__*/_jsxs(Box, {
      className: "flex w-full flex-row items-center space-x-2",
      children: [formTitleDirection === JoveFormTitleDirectionEnum.left && (formTitleSlot ? formTitleSlot : /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: clsx('font-bold', formTitleClassName),
        style: {
          color: props !== null && props !== void 0 && props.disabled ? 'rgba(0, 0, 0, 0.38)' : undefined
        },
        children: formTitle
      })), /*#__PURE__*/_jsxs(Box, {
        className: "flex w-0 flex-1 flex-col",
        children: [/*#__PURE__*/_jsx(Autocomplete, _objectSpread(_objectSpread({
          id: "jove-country-select"
        }, rest), {}, {
          getOptionLabel: function getOptionLabel(option) {
            return option[labelKey];
          },
          isOptionEqualToValue: function isOptionEqualToValue(option, value) {
            return option[valueKey] === value[valueKey];
          },
          value: value === undefined ? selectValue : value,
          onChange: selectValueChangeAction,
          renderOption: function renderOption(props, option) {
            return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
              component: "li",
              sx: {
                '& > img': {
                  mr: 2,
                  flexShrink: 0
                }
              }
            }, props), {}, {
              children: [/*#__PURE__*/_jsx("img", {
                loading: "lazy",
                width: "20",
                src: getCountryNormalLogoUrl(option[valueKey]),
                alt: ""
              }), option[labelKey], " (", option[valueKey], ")"]
            }), props[valueKey]);
          },
          renderInput: function renderInput(params) {
            return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, params), {}, {
              label: label
            }));
          },
          size: size,
          clearIcon: hideClearButton ? null : /*#__PURE__*/_jsx(CloseOutlined, {
            className: "h-5 w-5"
          }),
          options: canSelectOptions
        })), error && /*#__PURE__*/_jsx(FormHelperText, {
          error: error,
          children: errMessage
        })]
      })]
    })]
  });
});
export var JoveCountrySelectControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveCountrySelect, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      valueChange: valueChangeAction,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveCountrySelect;